import React from "react";
import { InfoTooltip } from "./ToolTip";

export interface IProps {
}

const HiddenProfileName: React.FunctionComponent<IProps> = (props) => {
  return(
    <p className="m-0">
      <strong>
        Skjult profilnavn
      </strong>
      <InfoTooltip title="Skjult profilinformasjon">
        Selgeren har valgt å skjule identiteten sin. Ved kontakt vil brukernavn og bilde bli tilgjengelig for kjøperen.
        {/* Brukernavn er ikke tilgjengelig akkurat nå, men du kan kontakte selgere gjennom meldingstjenesten. */}
      </InfoTooltip>
    </p>
  )
};

export default HiddenProfileName;

